import { p_sentinel_door_systems_new_website } from "./sentinel-door-systems-new-website";
import { p_oracle_training_consultants_new_website } from "./oracle-training-consultants-new-website";
import type { PageContent } from "../types";
import {
  getGeneratedBlogCardImage,
  getGeneratedBlogImage,
  getGeneratedBlogImagePlaceholder,
} from "./generated-image-manifest";

const DEFAULT_LAST_UPDATED = "2026-06-30";

import { p_2023_seo_lessons_and_forward_view } from "./2023-seo-lessons-and-forward-view";
import { p_2024_algorithm_updates_navigating_a_year_of_core_changes_and_spam_crackdowns } from "./2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns";
import { p_a_practical_plan_for_ai_driven_search_a_ninety_day_playbook } from "./a-practical-plan-for-ai-driven-search-a-ninety-day-playbook";
import { p_a_year_of_change_googles_2021_algorithm_updates } from "./a-year-of-change-googles-2021-algorithm-updates";
import { p_ai_in_search_the_rise_of_generative_experiences } from "./ai-in-search-the-rise-of-generative-experiences";
import { p_aligning_seo_with_revenue_goals_in_2025 } from "./aligning-seo-with-revenue-goals-in-2025";
import { p_barnsley_seo_for_accountants_how_to_attract_higher_value_leads } from "./barnsley-seo-for-accountants-how-to-attract-higher-value-leads";
import { p_barnsley_seo_for_builders_how_to_turn_google_searches_into_quote_requests } from "./barnsley-seo-for-builders-how-to-turn-google-searches-into-quote-requests";
import { p_barnsley_seo_for_dental_and_health_clinics_local_patient_growth } from "./barnsley-seo-for-dental-and-health-clinics-local-patient-growth";
import { p_barnsley_seo_for_solicitors_building_trust_and_qualified_enquiries } from "./barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries";
import { p_bert_expansion_and_passage_indexing } from "./bert-expansion-and-passage-indexing";
import { p_building_a_website_that_supports_seo_and_business_growth } from "./building-a-website-that-supports-seo-and-business-growth";
import { p_building_structured_data_and_schema_markup } from "./building-structured-data-and-schema-markup";
import { p_common_seo_mistakes_that_hold_small_businesses_back } from "./common-seo-mistakes-that-hold-small-businesses-back";
import { p_connecting_seo_to_revenue_in_an_ai_influenced_world_revision } from "./connecting-seo-to-revenue-in-an-ai-influenced-world-revision";
import { p_creating_an_seo_plan_that_supports_long_term_success } from "./creating-an-seo-plan-that-supports-long-term-success";
import { p_data_driven_decisions_leveraging_ga4_for_seo_success } from "./data-driven-decisions-leveraging-ga4-for-seo-success";
import { p_decoding_googles_2022_algorithm_updates } from "./decoding-googles-2022-algorithm-updates";
import { p_eat_and_the_evolution_of_content } from "./eat-and-the-evolution-of-content";
import { p_eeat_and_content_quality } from "./eeat-and-content-quality";
import { p_emerging_seo_specialties_aeo_geo_and_beyond } from "./emerging-seo-specialties-aeo-geo-and-beyond";
import { p_enterprise_seo_and_collaboration } from "./enterprise-seo-and-collaboration";
import { p_firstparty_data_and_privacy } from "./firstparty-data-and-privacy";
import { p_generative_ai_and_content_creation_balancing_automation_and_authenticity } from "./generative-ai-and-content-creation-balancing-automation-and-authenticity";
import { p_generative_ais_role_in_search_in_2023 } from "./generative-ais-role-in-search-in-2023";
import { p_how_accountancy_websites_can_improve_enquiry_quality } from "./how-accountancy-websites-can-improve-enquiry-quality";
import { p_how_builders_can_get_more_quote_requests_from_google } from "./how-builders-can-get-more-quote-requests-from-google";
import { p_how_hairdressers_can_get_more_bookings_from_google } from "./how-hairdressers-can-get-more-bookings-from-google";
import { p_how_law_firms_can_improve_search_led_enquiry_quality } from "./how-law-firms-can-improve-search-led-enquiry-quality";
import { p_how_long_does_seo_take_in_barnsley_a_practical_timeline } from "./how-long-does-seo-take-in-barnsley-a-practical-timeline";
import { p_how_long_does_seo_take_in_sheffield_a_practical_timeline } from "./how-long-does-seo-take-in-sheffield-a-practical-timeline";
import { p_how_much_does_seo_cost_for_a_barnsley_business_in_2026 } from "./how-much-does-seo-cost-for-a-barnsley-business-in-2026";
import { p_how_much_does_seo_cost_for_a_wakefield_business_in_2026 } from "./how-much-does-seo-cost-for-a-wakefield-business-in-2026";
import { p_how_seo_builds_momentum_over_time_for_small_businesses } from "./how-seo-builds-momentum-over-time-for-small-businesses";
import { p_how_to_hire_an_seo_consultant } from "./how-to-hire-an-seo-consultant";
import { p_how_to_optimise_your_google_business_profile } from "./how-to-optimise-your-google-business-profile";
import { p_indexnow_and_instant_indexing } from "./indexnow-and-instant-indexing";
import { p_introduction_of_mum_and_passage_ranking } from "./introduction-of-mum-and-passage-ranking";
import { p_january_2025_quiet_month_big_insights } from "./january-2025-quiet-month-big-insights";
import { p_july_2026_ai_search_what_small_businesses_should_do_now } from "./july-2026-ai-search-what-small-businesses-should-do-now";
import { p_july_2026_google_core_update_recovery_playbook } from "./july-2026-google-core-update-recovery-playbook";
import { p_lessons_and_predictions_for_2022 } from "./lessons-and-predictions-for-2022";
import { p_lessons_from_google_s_2025_algorithm_updates } from "./lessons-from-google-s-2025-algorithm-updates";
import { p_local_search_in_2025_personalisation_and_contextual_relevance } from "./local-search-in-2025-personalisation-and-contextual-relevance";
import { p_local_seo_and_ai_optimising_for_voice_and_community } from "./local-seo-and-ai-optimising-for-voice-and-community";
import { p_local_seo_and_the_consumer_journey } from "./local-seo-and-the-consumer-journey";
import { p_local_seo_enhancements_in_2023 } from "./local-seo-enhancements-in-2023";
import { p_local_seo_for_accountancy_firms_what_matters_most } from "./local-seo-for-accountancy-firms-what-matters-most";
import { p_local_seo_in_2022 } from "./local-seo-in-2022";
import { p_looking_ahead_lessons_from_2024_for_the_future } from "./looking-ahead-lessons-from-2024-for-the-future";
import { p_mobile_and_core_web_vitals_in_2023 } from "./mobile-and-core-web-vitals-in-2023";
import { p_mobilefirst_indexing_gains_pace } from "./mobilefirst-indexing-gains-pace";
import { p_multi_format_content_and_diversified_channels } from "./multi-format-content-and-diversified-channels";
import { p_navigating_googles_2023_core_and_spam_updates } from "./navigating-googles-2023-core-and-spam-updates";
import { p_november_2025_digital_marketing_trends_to_watch } from "./november-2025-digital-marketing-trends-to-watch";
import { p_omnichannel_and_social_search } from "./omnichannel-and-social-search";
import { p_peoplefirst_content_vs_search_enginefirst } from "./peoplefirst-content-vs-search-enginefirst";
import { p_preparing_for_2021_lessons_from_2020 } from "./preparing-for-2021-lessons-from-2020";
import { p_product_reviews_and_algorithm_updates } from "./product-reviews-and-algorithm-updates";
import { p_protecting_against_spam_and_algorithmic_penalties } from "./protecting-against-spam-and-algorithmic-penalties";
import { p_private_dental_seo_treatment_pages_that_convert_patients } from "./private-dental-seo-treatment-pages-that-convert-patients";
import { p_quality_content_and_e_e_a_t_raising_the_bar_for_trust } from "./quality-content-and-e-e-a-t-raising-the-bar-for-trust";
import { p_rethinking_seo_for_2025_putting_people_before_keywords } from "./rethinking-seo-for-2025-putting-people-before-keywords";
import { p_salon_treatment_pages_that_improve_seo_performance } from "./salon-treatment-pages-that-improve-seo-performance";
import { p_search_in_a_pandemic_changing_user_behaviour } from "./search-in-a-pandemic-changing-user-behaviour";
import { p_seo_for_contractors_winning_higher_value_project_enquiries } from "./seo-for-contractors-winning-higher-value-project-enquiries";
import { p_seo_for_electricians_emergency_versus_planned_search_intent } from "./seo-for-electricians-emergency-versus-planned-search-intent";
import { p_seo_for_plumbers_emergency_boiler_and_bathroom_search_intent } from "./seo-for-plumbers-emergency-boiler-and-bathroom-search-intent";
import { p_seo_in_2026_how_local_yorkshire_businesses_can_win_more_customers_from_google } from "./seo-in-2026-how-local-yorkshire-businesses-can-win-more-customers-from-google";
import { p_seo_in_an_ai_driven_search_world_what_small_businesses_need_to_focus_on } from "./seo-in-an-ai-driven-search-world-what-small-businesses-need-to-focus-on";
import { p_seo_mistakes_that_cost_builders_local_leads } from "./seo-mistakes-that-cost-builders-local-leads";
import { p_seo_strategy_for_small_businesses_building_consistent_enquiries_in_2026 } from "./seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026";
import { p_structured_data_and_rich_results } from "./structured-data-and-rich-results";
import { p_tackling_zero_click_searches_turning_visibility_into_value } from "./tackling-zero-click-searches-turning-visibility-into-value";
import { p_the_advent_of_zeroclick_results } from "./the-advent-of-zeroclick-results";
import { p_the_rise_of_brand_seo_building_authority_for_2025 } from "./the-rise-of-brand-seo-building-authority-for-2025";
import { p_the_rise_of_the_helpful_content_update } from "./the-rise-of-the-helpful-content-update";
import { p_turning_website_visitors_into_customers_with_seo } from "./turning-website-visitors-into-customers-with-seo";
import { p_understanding_googles_latest_algorithm_update } from "./understanding-googles-latest-algorithm-update";
import { p_user_experience_takes_centre_stage_core_web_vitals_2_0_and_beyond } from "./user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond";
import { p_video_and_visual_search } from "./video-and-visual-search";
import { p_voice_and_conversational_search } from "./voice-and-conversational-search";
import { p_voice_search_and_conversational_content } from "./voice-search-and-conversational-content";
import { p_voice_search_and_conversational_queries_in_2023 } from "./voice-search-and-conversational-queries-in-2023";
import { p_volatility_and_algorithm_resilience } from "./volatility-and-algorithm-resilience";
import { p_why_consistency_matters_more_than_quick_wins_in_seo } from "./why-consistency-matters-more-than-quick-wins-in-seo";
import { p_why_seo_is_still_one_of_the_best_investments_for_growing_businesses } from "./why-seo-is-still-one-of-the-best-investments-for-growing-businesses";
import { p_why_seo_should_be_driving_your_business_growth_not_just_rankings } from "./why-seo-should-be-driving-your-business-growth-not-just-rankings";
import { p_why_seo_starts_with_your_website_and_always_will } from "./why-seo-starts-with-your-website-and-always-will";

export const posts: PageContent[] = [
  p_sentinel_door_systems_new_website,
  p_oracle_training_consultants_new_website,
  p_2023_seo_lessons_and_forward_view,
  p_2024_algorithm_updates_navigating_a_year_of_core_changes_and_spam_crackdowns,
  p_a_practical_plan_for_ai_driven_search_a_ninety_day_playbook,
  p_a_year_of_change_googles_2021_algorithm_updates,
  p_ai_in_search_the_rise_of_generative_experiences,
  p_aligning_seo_with_revenue_goals_in_2025,
  p_barnsley_seo_for_accountants_how_to_attract_higher_value_leads,
  p_barnsley_seo_for_builders_how_to_turn_google_searches_into_quote_requests,
  p_barnsley_seo_for_dental_and_health_clinics_local_patient_growth,
  p_barnsley_seo_for_solicitors_building_trust_and_qualified_enquiries,
  p_bert_expansion_and_passage_indexing,
  p_building_a_website_that_supports_seo_and_business_growth,
  p_building_structured_data_and_schema_markup,
  p_common_seo_mistakes_that_hold_small_businesses_back,
  p_connecting_seo_to_revenue_in_an_ai_influenced_world_revision,
  p_creating_an_seo_plan_that_supports_long_term_success,
  p_data_driven_decisions_leveraging_ga4_for_seo_success,
  p_decoding_googles_2022_algorithm_updates,
  p_eat_and_the_evolution_of_content,
  p_eeat_and_content_quality,
  p_emerging_seo_specialties_aeo_geo_and_beyond,
  p_enterprise_seo_and_collaboration,
  p_firstparty_data_and_privacy,
  p_generative_ai_and_content_creation_balancing_automation_and_authenticity,
  p_generative_ais_role_in_search_in_2023,
  p_how_accountancy_websites_can_improve_enquiry_quality,
  p_how_builders_can_get_more_quote_requests_from_google,
  p_how_hairdressers_can_get_more_bookings_from_google,
  p_how_law_firms_can_improve_search_led_enquiry_quality,
  p_how_long_does_seo_take_in_barnsley_a_practical_timeline,
  p_how_long_does_seo_take_in_sheffield_a_practical_timeline,
  p_how_much_does_seo_cost_for_a_barnsley_business_in_2026,
  p_how_much_does_seo_cost_for_a_wakefield_business_in_2026,
  p_how_seo_builds_momentum_over_time_for_small_businesses,
  p_how_to_hire_an_seo_consultant,
  p_how_to_optimise_your_google_business_profile,
  p_indexnow_and_instant_indexing,
  p_introduction_of_mum_and_passage_ranking,
  p_january_2025_quiet_month_big_insights,
  p_july_2026_ai_search_what_small_businesses_should_do_now,
  p_july_2026_google_core_update_recovery_playbook,
  p_lessons_and_predictions_for_2022,
  p_lessons_from_google_s_2025_algorithm_updates,
  p_local_search_in_2025_personalisation_and_contextual_relevance,
  p_local_seo_and_ai_optimising_for_voice_and_community,
  p_local_seo_and_the_consumer_journey,
  p_local_seo_enhancements_in_2023,
  p_local_seo_for_accountancy_firms_what_matters_most,
  p_local_seo_in_2022,
  p_looking_ahead_lessons_from_2024_for_the_future,
  p_mobile_and_core_web_vitals_in_2023,
  p_mobilefirst_indexing_gains_pace,
  p_multi_format_content_and_diversified_channels,
  p_navigating_googles_2023_core_and_spam_updates,
  p_november_2025_digital_marketing_trends_to_watch,
  p_omnichannel_and_social_search,
  p_peoplefirst_content_vs_search_enginefirst,
  p_preparing_for_2021_lessons_from_2020,
  p_product_reviews_and_algorithm_updates,
  p_protecting_against_spam_and_algorithmic_penalties,
  p_private_dental_seo_treatment_pages_that_convert_patients,
  p_quality_content_and_e_e_a_t_raising_the_bar_for_trust,
  p_rethinking_seo_for_2025_putting_people_before_keywords,
  p_salon_treatment_pages_that_improve_seo_performance,
  p_search_in_a_pandemic_changing_user_behaviour,
  p_seo_for_contractors_winning_higher_value_project_enquiries,
  p_seo_for_electricians_emergency_versus_planned_search_intent,
  p_seo_for_plumbers_emergency_boiler_and_bathroom_search_intent,
  p_seo_in_2026_how_local_yorkshire_businesses_can_win_more_customers_from_google,
  p_seo_in_an_ai_driven_search_world_what_small_businesses_need_to_focus_on,
  p_seo_mistakes_that_cost_builders_local_leads,
  p_seo_strategy_for_small_businesses_building_consistent_enquiries_in_2026,
  p_structured_data_and_rich_results,
  p_tackling_zero_click_searches_turning_visibility_into_value,
  p_the_advent_of_zeroclick_results,
  p_the_rise_of_brand_seo_building_authority_for_2025,
  p_the_rise_of_the_helpful_content_update,
  p_turning_website_visitors_into_customers_with_seo,
  p_understanding_googles_latest_algorithm_update,
  p_user_experience_takes_centre_stage_core_web_vitals_2_0_and_beyond,
  p_video_and_visual_search,
  p_voice_and_conversational_search,
  p_voice_search_and_conversational_content,
  p_voice_search_and_conversational_queries_in_2023,
  p_volatility_and_algorithm_resilience,
  p_why_consistency_matters_more_than_quick_wins_in_seo,
  p_why_seo_is_still_one_of_the_best_investments_for_growing_businesses,
  p_why_seo_should_be_driving_your_business_growth_not_just_rankings,
  p_why_seo_starts_with_your_website_and_always_will,
];

export function getPost(slug: string): PageContent | undefined {
  const post = posts.find((p) => p.slug === slug && isPublishedPost(p));
  return post ? withGeneratedBlogImage(post) : undefined;
}

export function listPosts(): PageContent[] {
  return posts
    .filter(isPublishedPost)
    .map(withGeneratedBlogImage)
    .sort((a, b) => (b.date ?? "").localeCompare(a.date ?? ""));
}

function isPublishedPost(post: PageContent): boolean {
  if (!post.date) return true;
  return post.date <= new Date().toISOString().slice(0, 10);
}

function withGeneratedBlogImage(post: PageContent): PageContent {
  const body = stripScrapedBlogBoilerplate(post.body).replace(
    /https:\/\/www\.phil-carr\.co\.uk\/images\/blog\/([^)\]\s"']+)\.(?:jpg|jpeg|png|webp)/gi,
    (_match, slug) => getGeneratedBlogImage(slug),
  );

  return {
    ...post,
    image: getBlogPostImage({ ...post, body }),
    body,
    // Prefer an explicit per-post lastUpdated; otherwise fall back to the
    // post's own publish date so newly-published articles don't display a
    // "Last updated" that predates them. Historical posts without either
    // field use the shared default (a plausible recent date, never today).
    lastUpdated: post.lastUpdated ?? post.date ?? DEFAULT_LAST_UPDATED,
  };
}

export function getBlogPostImage(post: PageContent): string {
  const generatedImage = getGeneratedBlogImage(post.slug);
  const bodyImage = getFirstMarkdownImage(post.body);

  if (post.image) return post.image;
  if (bodyImage && getGeneratedImageSlug(bodyImage) === post.slug) return generatedImage;
  return bodyImage ?? generatedImage;
}

export function getBlogPostCardImage(post: PageContent): string {
  return getGeneratedBlogCardImage(post.slug);
}

export function getBlogPostImagePlaceholder(post: Pick<PageContent, "slug">): string {
  return getGeneratedBlogImagePlaceholder(post.slug);
}

function getFirstMarkdownImage(body: string): string | undefined {
  return body.match(/^\s*!\[[^\]]*]\(([^)]+)\)\s*$/m)?.[1]?.trim();
}

function getGeneratedImageSlug(src: string): string | undefined {
  return src
    .match(/\/images\/blog\/generated\/([^/?#)]+)\.(?:jpg|jpeg|png|webp)(?:[?#][^)]+)?$/i)?.[1]
    ?.trim();
}

function stripScrapedBlogBoilerplate(body: string): string {
  const cutMarkers = [
    "## Other News Articles",
    "We use cookies to improve your experience",
    "Reject optionalAccept cookies",
    "reCAPTCHA",
  ];

  let cleaned = body;
  for (const marker of cutMarkers) {
    const index = cleaned.indexOf(marker);
    if (index !== -1) cleaned = cleaned.slice(0, index).trimEnd();
  }

  return cleaned;
}
